module.exports = __webpack_public_path__ + "img/mascotas.8f8be26a.svg";